/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Label_NotesInputs */

const en_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes (optional)`)
};

const es_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas (opcional)`)
};

const de_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen (optional)`)
};

const zh_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备注（可选）`)
};

const ar_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظات (اختياري)`)
};

const fr_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarques (facultatif)`)
};

const vi_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú (không bắt buộc)`)
};

const sw_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidokezo (si lazima)`)
};

const th_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมายเหตุ (ไม่บังคับ)`)
};

const bs_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napomene (opcionalno)`)
};

const ja_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモ（任意）`)
};

const ko_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메모 (선택)`)
};

const pt_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observações (opcional)`)
};

const it_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note (opzionale)`)
};

const sv_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteckningar (valfritt)`)
};

const nl_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opmerkingen (facultatief)`)
};

const da_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bemærkninger (valgfrit)`)
};

const nb_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merknader (valgfritt)`)
};

const fi_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huomautukset (vapaaehtoinen)`)
};

const pl_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwagi (nieobowiązkowe)`)
};

const ru_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания (необязательно)`)
};

const tr_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notlar (isteğe bağlı)`)
};

const hi_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स (वैकल्पिक)`)
};

const id_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan (opsional)`)
};

const ms_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota (pilihan)`)
};

const cs_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky (nepovinné)`)
};

const el_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σημειώσεις (προαιρετικά)`)
};

const he_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הערות (אופציונלי)`)
};

const af_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas (opsioneel)`)
};

const hu_booking_label_notes = /** @type {(inputs: Booking_Label_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjegyzések (nem kötelező)`)
};

/**
* | output |
* | --- |
* | "Notes (optional)" |
*
* @param {Booking_Label_NotesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_label_notes = /** @type {((inputs?: Booking_Label_NotesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Label_NotesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_label_notes(inputs)
	if (locale === "de") return de_booking_label_notes(inputs)
	if (locale === "zh") return zh_booking_label_notes(inputs)
	if (locale === "ar") return ar_booking_label_notes(inputs)
	if (locale === "fr") return fr_booking_label_notes(inputs)
	if (locale === "vi") return vi_booking_label_notes(inputs)
	if (locale === "sw") return sw_booking_label_notes(inputs)
	if (locale === "th") return th_booking_label_notes(inputs)
	if (locale === "bs") return bs_booking_label_notes(inputs)
	if (locale === "ja") return ja_booking_label_notes(inputs)
	if (locale === "ko") return ko_booking_label_notes(inputs)
	if (locale === "pt") return pt_booking_label_notes(inputs)
	if (locale === "it") return it_booking_label_notes(inputs)
	if (locale === "sv") return sv_booking_label_notes(inputs)
	if (locale === "nl") return nl_booking_label_notes(inputs)
	if (locale === "da") return da_booking_label_notes(inputs)
	if (locale === "nb") return nb_booking_label_notes(inputs)
	if (locale === "fi") return fi_booking_label_notes(inputs)
	if (locale === "pl") return pl_booking_label_notes(inputs)
	if (locale === "ru") return ru_booking_label_notes(inputs)
	if (locale === "tr") return tr_booking_label_notes(inputs)
	if (locale === "hi") return hi_booking_label_notes(inputs)
	if (locale === "id") return id_booking_label_notes(inputs)
	if (locale === "ms") return ms_booking_label_notes(inputs)
	if (locale === "cs") return cs_booking_label_notes(inputs)
	if (locale === "el") return el_booking_label_notes(inputs)
	if (locale === "he") return he_booking_label_notes(inputs)
	if (locale === "af") return af_booking_label_notes(inputs)
	if (locale === "hu") return hu_booking_label_notes(inputs)
	return en_booking_label_notes(inputs)
});